export const titleAlert = {
    'confirm_submit_1': 'ຢືນຢັນການສົ່ງ?',
    'confirm_submit_2': 'ຢືນຢັນການສົ່ງ?',
    'confirm_submit_3': 'ຢືນຢັນການສົ່ງ?',
};

